import { Injectable } from '@angular/core';
import { errorMessages } from '../configs/error-messages.config'; // Import the error messages array

@Injectable({
  providedIn: 'root' // Makes this service available throughout your app
})
export class ErrorService {

  constructor() {}
  errorMessage:string='';
  // Method to get error message based on status code
  getErrorMessage(statusCode: number): string {
    const error = errorMessages.find(err => err.statusCode === statusCode);
    return error ? error.errorMessage : 'Unknown Error: No matching status code found.';
  }
}

